export function detectBrowser(): string {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Edg")) {
        return "Microsoft Edge";
    } else if (userAgent.includes("Trident")) {
        return "Internet Explorer";
    } else if (userAgent.includes("Samsung")) {
        return "Samsung Internet"; // Detect Samsung Internet
    } else if (userAgent.includes("wv") && userAgent.includes("Android") && userAgent.includes("Chrome")) {
        return "Android WebView"; // Detect Android WebView
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
        return "Google Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        return "Safari";
    } else if (userAgent.includes("Firefox")) {
        return "Firefox";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
        return "Opera";
    } else {
        return "Other";
    }
}